<div class="column-header"
     [ngClass]="{'has-user': column.user}"
     style.background-color="#{{column.user ? column.user.bgColor : 'FFF'}}">
    <!-- dummy check -->
<!--    <div class="header-line" *ngIf="column.type !== 'engineering'">{{column.header}}</div>-->
    <div class="header-line">{{column.title}}</div>
</div>
<div class="scroll-container" #scrollWrapper cdkScrollable>

  <div class="columns-container"
       *ngFor="let group of column.groups"
       [attr.data-before-content]="group.title"
       cdkDropList (cdkDropListDropped)="tileDrop($event)" [cdkDropListData]="group"
       [ngClass]="{'empty': group.activities.length === 0,
                    'has-title': column.user || column.title === 'Unassigned'}">
          <app-engineering-tile class="tile" cdkDrag *ngFor="let tile of group.activities" cdkDragData="tile"
              [tile]="tile"
              [showUser]="column.title === 'Completed' && tile.userId	!== null"
              [showStatusChangeReason]="group.title === 'On hold'"
              [isMobile]="device === 'isMobile' || device === 'isTablet'">
              <div class="ellipsis-to-drag" *ngIf="device === 'isMobile' || device === 'isTablet'">
                  <mat-icon class="ellipsis-icon" cdkDragHandle>more_horiz</mat-icon>
              </div>
          </app-engineering-tile>
  </div>

</div>
